import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import WheatPastaProduct from 'models/WheatPastaProduct'
import WheatPastaNutrition from './WheatPastaNutrition'
import WheatPastaPackage from './WheatPastaPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc
      initialBrandNameOptions={brandNameOptions}
      isSRPURequired={false}
    />
  ),
  nutritionInfo: <WheatPastaNutrition />,
  packagingInfo: <WheatPastaPackage />,
  productTitle: 'Whole Wheat Pasta',
  model: WheatPastaProduct,
  validCategories: ['16'],
  validSubCategories: ['009'],
  brandSpecific: false,
}

const WheatPasta = () => <ProductForm product={productOptions} />

export default WheatPasta
